import React from "react";

const VisionMission = () => {
    const cards = [
        {
            title: "Our Mission",
            description:
                "To ensure equitable healthcare access for all by creating pathways that connect patients to the services they need while addressing systemic barriers to care.",

            bgColor: "#45E99E",
        },
        {
            title: "Our Vision",
            description:
                "A world where healthcare is accessible, affordable, and equitable for everyone, especially those who are often overlooked by traditional healthcare systems.",
            bgColor: "#DFFBEE",
        },
    ];

    return (
        <div
            className="bg-[#F6FEFA] h-auto"
        >
            <div className="max-w-[1440px] w-[90%] mx-auto flex flex-col lg:flex-row lg:justify-between justify-center items-center py-16 gap-8">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        className="max-w-[612px] w-full h-full flex flex-col justify-between items-start px-6 pt-10 pb-16 gap-y-9 rounded-[30px]"
                        style={{ backgroundColor: card.bgColor }}
                    >
                        <h3 className="text-3xl md:text-5xl font-medium mb-4 text-[#025788]">
                            {card.title}
                        </h3>
                        <p className="text-2xl leading-8 font-normal text-[#025788] lg:w-[98%]">
                            {card.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VisionMission;
